<template>
  <v-dialog
    v-model="dialog"
    max-width="600px"
    scrollable
    v-if="hasEdit('customers')"
  >
    <template v-slot:activator="{ on }">
      <v-btn height="40px" color="primary" depressed v-on="on"
        >Billing Information
      </v-btn>
    </template>
    <dialog-card
      title="Billing Information"
      @close="dialog = false"
      :is-submit="false"
    >
      <div class="d-flex mb-3" v-if="hasEdit('customers')">
        <v-spacer></v-spacer>
        <add-client-payment-method-dialog
          @onPaymentMethod="fetchPaymentMethods"
        />
      </div>
      <please-wait v-if="isLoading" />
      <template v-else>
        <v-card
          outlined
          v-for="(item, i) in list"
          :key="i"
          class="mb-3"
          :class="{ 'primary-payment': item.is_primary }"
        >
          <v-list-item>
            <v-list-item-action>
              <v-img width="40px" v-if="getLogo(item)" :src="getLogo(item)" />
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <div class="d-flex align-center">
                <mark-primary-card-button
                  :item="item"
                ></mark-primary-card-button>
                <add-client-payment-method-dialog
                  :payment-method="item"
                  :isEdit="true"
                  @onPaymentMethod="fetchPaymentMethods"
                  v-if="hasEdit('customers')"
                />

                <delete-icon-button
                  @click="removePayment(item)"
                  v-if="hasDelete('customers')"
                />
              </div>
            </v-list-item-action>
          </v-list-item>
        </v-card>
      </template>
    </dialog-card>
  </v-dialog>
</template>

<script>
import DialogCard from "@/components/ui/DialogCard.vue";
import DeleteIconButton from "@/components/ui/buttons/DeleteIconButton.vue";
import AddClientPaymentMethodDialog from "./AddClientPaymentMethodDialog.vue";
import PleaseWait from "@/components/ui/PleaseWait.vue";
import {collection, getDocs, orderBy, query} from "firebase/firestore";
import {colClients, functions} from "@/assets/utils/firebase.utils";
import {mapDocs} from "@/assets/utils/doc.utils";
import {clientPaymentTypes} from "@/assets/constants/client.constants";
import {httpsCallable} from "firebase/functions";
import Tooltip from "@/components/ui/Tooltip.vue";
import MarkPrimaryCardButton from "@/components/clients/clientProfile/MarkPrimaryCardButton.vue";

export default {
  components: {
    MarkPrimaryCardButton,
    Tooltip,
    DialogCard,
    DeleteIconButton,
    AddClientPaymentMethodDialog,
    PleaseWait,
  },
  data() {
    return {
      dialog: false,
      isLoading: true,
      list: [],
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        this.fetchPaymentMethods(false);
      }
    },
  },
  provide() {
    return {
      fetchPaymentMethods: this.fetchPaymentMethods,
    };
  },
  methods: {
    getLogo(item) {
      if (item.payment_method === "Credit Card") {
        let title = (item.title || "").toString().toLowerCase();
        if (title.includes("visa"))
          return require("@/assets/images/card/visa.svg");
        if (title.includes("amex"))
          return require("@/assets/images/card/amex.svg");
        if (title.includes("jcb"))
          return require("@/assets/images/card/jcb.svg");
        if (title.includes("amex"))
          return require("@/assets/images/card/amex.svg");
        if (title.includes("mastercard"))
          return require("@/assets/images/card/mastercard.png");
        if (title.includes("discover"))
          return require("@/assets/images/card/discover.svg");
        if (title.includes("diners"))
          return require("@/assets/images/card/diners.svg");
      }
      return item.logo;
    },
    removePayment({ id }) {
      this.$confirm.show({
        message: `Are you sure, Do you want to remove this?`,
        onConfirm: async () => {
          let addMethod = httpsCallable(functions, "manageClientPaymentMethod");
          await addMethod({
            type: "delete-pm",
            customer: this.$route.params.id,
            id: id,
          });
          this.fetchPaymentMethods();
        },
      });
    },
    async fetchPaymentMethods(isLoading = true) {
      try {
        this.isLoading = isLoading;
        let col = collection(
          colClients,
          this.$route.params.id,
          "payment_methods"
        );
        const list = mapDocs(
          (await getDocs(query(col, orderBy("created_at", "desc")))).docs
        ).map((i) => {
          let paymentMethod = clientPaymentTypes.find(
            (p) => p.value === i.payment_method
          );
          if (paymentMethod) {
            i.logo = paymentMethod.logo;
            i.title = i[paymentMethod.title];
          }
          return i;
        });
        this.list = [
          ...list.filter((i) => i.is_primary),
          ...list.filter((i) => !i.is_primary),
        ];
        this.isLoading = false;
      } catch (error) {
        this.handleError(error);
      }
    },
  },
  mounted() {
    this.fetchPaymentMethods();
  },
};
</script>
